export default {
      id: "ic-sign-up-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-sign-up-usage",
      toString: function () {
        return this.url;
      }
    }